export const departmentToZone = {
  H1: [
    "01 Ain",
    "02 Aisne",
    "03 Allier",
    "05 Hautes Alpes",
    "08 Ardennes",
    "10 Aube",
    "14 Calvados",
    "15 Cantal",
    "19 Corrèze",
    "21 Cote dor",
    "23 Creuse",
    "25 Doubs",
    "27 Eure",
    "28 Eure et Loir",
    "38 Isère",
    "39 Jura",
    "42 Loire",
    "43 Haute Loire",
    "45 Loiret",
    "51 Marne",
    "52 Haute Marne",
    "54 Meurthe et Moselle",
    "55 Meuse",
    "57 Moselle",
    "58 Nièvre",
    "59 Nord",
    "60 Oise",
    "61 Orne",
    "62 Pas de Calais",
    "63 Puy de Dôme",
    "67 Bas Rhin",
    "68 Haut Rhin",
    "69 Rhône",
    "70 Haute Saône",
    "71 Saône et Loire",
    "73 Savoie",
    "74 Haute Savoie",
    "75 Paris",
    "76 Seine Maritime",
    "77 Seine et Marne",
    "78 Yvelines",
    "80 Somme",
    "87 Haute Vienne",
    "88 Vosges",
    "89 Yonne",
    "90 Territoire de Belfort",
    "91 Essonne",
    "92 Hauts de Seine",
    "93 Seine Saint Denis",
    "94 Val de Marne",
    "95 Val dOise",
    "975 St Pierre et Miquelon",
  ],
  H2: [
    "04 Alpes de Haute Provence",
    "07 Ardèche",
    "09 Ariège",
    "12 Aveyron",
    "16 Charente",
    "17 Charente Maritime",
    "18 Cher",
    "22 Cotes dArmor",
    "24 Dordogne",
    "26 Drome",
    "29 Finistère",
    "31 Haute Garonne",
    "32 Gers",
    "33 Gironde",
    "35 Ile et Vilaine",
    "36 Indre",
    "37 Indre et Loire",
    "40 Landes",
    "41 Loir et Cher",
    "44 Loire Atlantique",
    "46 Lot",
    "47 Lot et Garonne",
    "48 Lozère",
    "49 Maine et Loire",
    "50 Manche",
    "53 Mayenne",
    "56 Morbihan",
    "64 Pyrénées Atlantiques",
    "65 Hautes Pyrénées",
    "72 Sarthe",
    "79 Deux Sèvres",
    "81 Tarn",
    "82 Tarn et Garonne",
    "84 Vaucluse",
    "85 Vendée",
    "86 Vienne",
  ],
  H3: [
    "06 Alpes Maritimes",
    "11 Aude",
    "13 Bouches Du Rhône",
    "20 Corse",
    "30 Gard",
    "34 Hérault",
    "66 Pyrénées Orientales",
    "83 Var",
    "971 Guadeloupe",
    "972 Martinique",
    "973 Guyane",
    "974 La Réunion",
    "976 Mayotte",
  ],
};

export const climateOptions = {
  "IND-UT-116": ["Climatisation de confort dun local (hors datacenter)"],
  "BAT-TH-134": [
    "Climatisation de confort dun local (hors datacenter)",
    "Climatisation dun datacenter",
    "Autres applications de type réfrigération ou conditionnement dambiance hors confort des occupants",
  ],
  "AGRI-UT-104": ["Condensation par rapport à latmosphère"],
};


export const cumacData = {
    "IND-UT-116": {
      "Climatisation de confort dun local (hors datacenter)": {
        H1: 14300,
        H2: 14300,
        H3: 13500
      }
    },
    "BAT-TH-134": {
      "Climatisation de confort dun local (hors datacenter)": {
        H1: 2000,
        H2: 1800,
        H3: 1600
      },
      "Climatisation dun datacenter": {
        H1: 22800,
        H2: 20500,
        H3: 20200
      },
      "Autres applications de type réfrigération ou conditionnement dambiance hors confort des occupants": {
        H1: 19100,
        H2: 17000,
        H3: 16400
      }
    },
    "AGRI-UT-104": {
      "Condensation par rapport à latmosphère": {
        H1: 10600,
        H2: 10600,
        H3: 9700
      }
    }
  };
  

export const carbontableData = [
  { country: "France", intensity: 0.085, price1: "0.276 €", price2: "0.253 €" },
  { country: "Spain", intensity: 0.217, price1: "0.157 €", price2: "0.128 €" },
  { country: "Italy", intensity: 0.372, price1: "0.224 €", price2: "0.190 €" },
  {
    country: "Germany",
    intensity: 0.386,
    price1: "0.213 €",
    price2: "0.190 €",
  },
  {
    country: "Belgium",
    intensity: 0.165,
    price1: "0.207 €",
    price2: "0.186 €",
  },
  {
    country: "Luxembourg",
    intensity: 0.168,
    price1: "0.282 €",
    price2: "0.248 €",
  },
  {
    country: "Netherlands",
    intensity: 0.361,
    price1: "0.213 €",
    price2: "0.193 €",
  },
  {
    country: "Portugal",
    intensity: 0.234,
    price1: "0.192 €",
    price2: "0.144 €",
  },
  {
    country: "Ireland",
    intensity: 0.342,
    price1: "0.343 €",
    price2: "0.282 €",
  },
  {
    country: "United Kingdom",
    intensity: 0.268,
    price1: "",
    price2: "0.220 €",
  },
  { country: "Poland", intensity: 0.635, price1: "0.171 €", price2: "0.139 €" },
  {
    country: "Denmark",
    intensity: 0.181,
    price1: "0.154 €",
    price2: "0.124 €",
  },
  {
    country: "Finland",
    intensity: 0.132,
    price1: "0.121 €",
    price2: "0.091 €",
  },
  { country: "Sweden", intensity: 0.045, price1: "0.111 €", price2: "0.098 €" },
  { country: "Norway", intensity: 0.026, price1: "0.090 €", price2: "0.090 €" },
  {
    country: "EU average",
    intensity: 0.278,
    price1: "0.184 €",
    price2: "0.159 €",
  },
];
